import React from "react";
import numberWithCommas from "../RTK/utils/numberWithComma";
import { useDispatch, useSelector } from "react-redux";
import { fetchAllTransactions } from "../RTK/Features/Transaction/TrnasactionSlice";
function FormHeader() {
  const { balance } = useSelector((state) => state.transaction);

  return (
    <div className="bg-sky-700	 p-4 h-full w-[400px]">
      <p className="text-md text-slate-300">Your Current Balance:</p>
      <p className="text-3xl font-bold text-slate-300">
        <span className="text-3xl">৳</span> {numberWithCommas(balance)}
      </p>
    </div>
  );
}

export default FormHeader;
